import { render, staticRenderFns } from "./VContentList.vue?vue&type=template&id=72cc9d45&"
import script from "./VContentList.vue?vue&type=script&lang=ts&"
export * from "./VContentList.vue?vue&type=script&lang=ts&"
import style0 from "./VContentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports